/* eslint-disable @typescript-eslint/no-shadow */
import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import * as XLSX from 'xlsx';

import { ZARcurrencyPipe } from '../../pipes/zarcurrency.pipe';
import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';
import { LmsTableWrapperComponent } from '../../ui/lms-table-wrapper/lms-table-wrapper.component';

// Import large libraries dynamically
async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-override-report',
  templateUrl: './override-report.component.html',
  styleUrls: ['./override-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ZARcurrencyPipe,
    NgxPaginationModule,
    LmsModalFrameComponent,
    LmsTableWrapperComponent,
  ],
})
export class OverrideReportComponent implements OnInit {
  overrideList: any[] = [];
  title = 'export-excel';
  fileName = '';
  @ViewChild('TABLE') table: ElementRef;
  dataSource = this.overrideList;
  config = {
    id: 'pager',
    itemsPerPage: 10,
    currentPage: 1,
  };

  docCount = 1;

  constructor(
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<OverrideReportComponent>,
  ) {}


exportLogsToExcel(): void {
  this.title = 'export-excel';
  this.fileName = `Override Log Report_${new Date().toISOString().slice(0,10)}.xlsx`;

  this.global_utility.startLoading('Exporting data to Excel.');
  loadXLSX()
    .then((XLSX) => {
      // Get the worksheet from the table
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);

      // Find which column contains IDs (adjust if needed)
      const idColumnIndex = 5; // Change this to your ID column index
      const idColumnLetter = XLSX.utils.encode_col(idColumnIndex);

      // Force text format for the ID column
      const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
      for (let row = range.s.r; row <= range.e.r; row++) {
        const cellAddress = `${idColumnLetter}${row + 1}`; // +1 because Excel is 1-based
        if (!ws[cellAddress]) continue;

        // Method 1: Set cell type to string
        ws[cellAddress].t = 's'; // 's' for string type
      }

      // Create workbook and save
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, this.fileName);

      this.global_utility.stopLoading();
    })
    .catch((err) => {
      console.error('Failed to export Excel:', err);
      this.global_utility.stopLoading();
    });
}

  ngOnInit(): void {
    console.log('OverrideReportComponent initialized');
    console.log(this.overrideList);
  }

  close() {
    this.dialogRef.close();
  }
}
